import React from 'react'
import Table, {
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel
} from 'material-ui/Table'
import { ReactTableDefaults } from 'react-table'

const TrGroupComponent = ({ children, ...rest }) => children

const ThComponent = ({ children, toggleSort, className, ...rest }) => {
  const matcher = /-sort-(desc|asc)/
  const active = matcher.test(className)
  const direction = active ? className.match(matcher)[1] : null
  return (
    <TableCell>
      <TableSortLabel
        active={active}
        direction={direction}
        onClick={toggleSort}
        className={className}
      >
        {children}
      </TableSortLabel>
    </TableCell>
  )
}

const PaginationComponent = ({ total, pageSize, page, onPageChange, onPageSizeChange }) => (
  <Table>
    <TableFooter>
      <TableRow>
        <TablePagination
          count={total}
          rowsPerPage={pageSize}
          page={page}
          onChangePage={(e, page) => onPageChange(page)}
          onChangeRowsPerPage={e => onPageSizeChange(e.target.value, page)}
        />
      </TableRow>
    </TableFooter>
  </Table>
)

Object.assign(ReactTableDefaults, {
  TableComponent: Table,
  TheadComponent: TableHead,
  TbodyComponent: TableBody,
  TrGroupComponent: TrGroupComponent,
  TrComponent: TableRow,
  ThComponent: ThComponent,
  TdComponent: TableCell,
  // TfootComponent: component,
  // ExpanderComponent: component,
  // AggregatedComponent: component,
  // PivotValueComponent: component,
  // PivotComponent: component,
  // FilterComponent: component,
  PaginationComponent: PaginationComponent
  // PreviousComponent: undefined,
  // NextComponent: undefined,
  // LoadingComponent: component,
  // NoDataComponent: component,
  // ResizerComponent: component
})



// WEBPACK FOOTER //
// ./src/table.js